import Vue from 'vue';
import Vuex from 'vuex';

import TranslationStore from "./modules/TranslationStore";
import AssessmentAlertsStore from "./modules/AssessmentAlertsStore";

import ProductListStore from './modules/ProductListStore';
import AssessmentStartStore from './modules/AssessmentStartStore';
import UserStore from './modules/UserStore';
import ChooseMainSymptomStore from './modules/ChooseMainSymptomStore';
import SymptomsQuestionsStore from "./modules/SymptomsQuestionsStore";
import ScoringStore from "./modules/ScoringStore";
import SummaryStore from "./modules/SummaryStore";
import AssessmentShareStore from "./modules/AssessmentShareStore";
import EvaluationStore from "./modules/EvaluationStore";
import AssessmentListStore from "./modules/AssessmentListStore";
import TestStore from "./modules/TestStore";
import SubmittedValuesStore from "./modules/SubmittedValuesStore";
import MedicalDeviceInfoStore from "./modules/MedicalDeviceInfoStore";
import DocStore from "./modules/DocStore";
import ThemeStore from "./modules/ThemeStore";
import VitalParametersStore from "./modules/VitalParametersStore";

import ChatBotStore from "./modules/pathfinder/chatbot/ChatBotStore";
import PfProductListStore from "./modules/pathfinder/standard-forms/PfProductListStore";
import PfAssessmentStartStore from "./modules/pathfinder/standard-forms/PfAssessmentStartStore";
import PfMainSymptomStore from "./modules/pathfinder/standard-forms/PfMainSymptomStore";
import PfRelatedSymptomsStore from "./modules/pathfinder/standard-forms/PfRelatedSymptomsStore";
import PfSymptomsQuestionsStore from "./modules/pathfinder/standard-forms/PfSymptomsQuestionsStore";
import PfSharedQuestionsStore from "./modules/pathfinder/standard-forms/PfSharedQuestionsStore";
import PfEvaluationStore from "./modules/pathfinder/standard-forms/PfEvaluationStore";


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        TranslationStore: TranslationStore,
        AssessmentAlertsStore: AssessmentAlertsStore,
        ProductListStore: ProductListStore,
        AssessmentStartStore: AssessmentStartStore,
        UserStore: UserStore,
        ChooseMainSymptomStore: ChooseMainSymptomStore,
        SymptomsQuestionsStore: SymptomsQuestionsStore,
        ScoringStore: ScoringStore,
        SummaryStore: SummaryStore,
        AssessmentShareStore: AssessmentShareStore,
        EvaluationStore: EvaluationStore,
        AssessmentListStore: AssessmentListStore,
        TestStore: TestStore,
        SubmittedValuesStore: SubmittedValuesStore,
        MedicalDeviceInfoStore: MedicalDeviceInfoStore,
        ChatBotStore: ChatBotStore,
        PfProductListStore: PfProductListStore,
        PfAssessmentStartStore: PfAssessmentStartStore,
        PfMainSymptomStore: PfMainSymptomStore,
        PfRelatedSymptomsStore: PfRelatedSymptomsStore,
        PfSymptomsQuestionsStore: PfSymptomsQuestionsStore,
        PfSharedQuestionsStore: PfSharedQuestionsStore,
        PfEvaluationStore: PfEvaluationStore,
        DocStore: DocStore,
        ThemeStore: ThemeStore,
        VitalParametersStore: VitalParametersStore
    },

    // strict: debug,
    // plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/common/store/index.js